// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2LnsO","largestCol":"styles_largestCol__1KGow","smallestCol":"styles_smallestCol__1MTrc"};